import _ from "lodash";
import { StructuralFolder } from "./types";

export function organizeByClient(
  folders: StructuralFolder[]
): StructuralFolder[] {
  const clientFolders = _.chain(folders)
    .flatMap((structuralFolder) =>
      structuralFolder.clientFolders.map((clientFolder) => ({
        ...clientFolder,
        structuralFolder,
      }))
    )
    .groupBy((x) => x.path)
    .value();

  const topLevelFolders = Object.keys(clientFolders).map(
    (x) =>
      ({
        path: x,
        __typename: "StructuralFolder",
        clientFolders: clientFolders[x].map((child) => ({
          ...child,
          path: `${child.structuralFolder.path}\\${x}`,
        })),
      } as StructuralFolder)
  );

  return topLevelFolders;
}
